import { render, staticRenderFns } from "./realTimeInfoClassList.vue?vue&type=template&id=b43b987e&scoped=true"
import script from "./realTimeInfoClassList.vue?vue&type=script&lang=js"
export * from "./realTimeInfoClassList.vue?vue&type=script&lang=js"
import style0 from "./realTimeInfoClassList.vue?vue&type=style&index=0&id=b43b987e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43b987e",
  null
  
)

export default component.exports